























import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import {
	defineComponent,
	PropType,
	ref,
	Ref,
	watch,
} from '@vue/composition-api';
import cloneDeep from 'clone-deep';
import { AnyHighlightChildRequest } from '../model';
import { EDITORS_BY_TYPE } from '../util/adminComponentsByType';
import { areSame } from '../util/compare';

export default defineComponent({
	components: {
		SlidingPanel,
		ScrollingColumn,
	},
	props: {
		isOpen: Boolean,
		groupId: {
			type: String,
			required: true,
		},
		value: {
			type: Object as PropType<AnyHighlightChildRequest | undefined>,
			default: undefined,
		},
	},
	setup(props, ctx) {
		// Having a cached item allows us to reset on cancel to the previously
		// cached version.
		const cachedItem: Ref<AnyHighlightChildRequest | undefined> = ref(undefined);
		watch(() => props.value, (curr, prev) => {
			if (!curr || !prev || cachedItem.value === undefined || !areSame(curr, prev)) {
				cachedItem.value = cloneDeep(curr);
			}
		}, { immediate: true });

		const cancel = () => {
			ctx.emit('input', cachedItem.value);
			cachedItem.value = undefined;
			ctx.emit('close');
		};
		return {
			cancel,
			EDITORS_BY_TYPE,
		};
	},
});
